import moment from 'moment';

export const dateUTCToLocale = (d: any | string, format?: string) => {
  const utcDate = moment.utc(d);
  const localDate = utcDate.local();
  return localDate.format(format);
};

export function dateLocaleToUTC(d: Date | string, format?: string) {
  const localDate = moment(d);
  const utcDate = localDate.utc();
  return utcDate.format(format);
}
